import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    popdown: {
        position: "relative",
        padding: "0",
        backgroundColor: "white",
        border: `0.0625rem solid ${theme.colors.gray[2]}`,
        borderRadius: "0.25rem",
        boxShadow: theme.shadows.xl,
        height: "42rem",
        width: "55rem",
    },
    headerContainer: {
        fontSize: "1.25rem",
        fontWeight: 500,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: "1.5rem 2rem",
    },
    tabsContainer: {
        padding: "0 0 0 1.875rem",
    },
    tabLabel: {
        fontSize: "0.875rem",
        color: theme.colors.gray[7],
        padding: "0 0 1rem 0",
        marginRight: "3rem",
        "& svg": {
            marginRight: "0.375rem",
        },
    },
    panel: {
        height: "28rem",
        padding: 0,
    },
    footerContainer: {
        borderTop: `0.0625rem solid ${theme.colors.gray[2]}`,
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        bottom: 0,
        padding: "0.6rem 1rem",
        width: "100%",
    },
    searchTips: {
        background: "white",
        ".mantine-Button-label": {
            color: theme.colors.violet[7],
            fontSize: "0.75rem",
            fontWeight: 500,
        },
        "&:hover, &:focus": {
            border: "none",
            background: "white",
            boxShadow: "none",
        },
    },
}))
